import { ResourceClient } from '@resourceful-hono/core';
import type { AttestationResource } from './index.ts';

export class AttestationResourceClient
  extends ResourceClient<AttestationResource> {
  constructor(resource: typeof AttestationResource, origin?: string) {
    super(resource, origin);
  }

  public createAttestationEvent = async (email: string) => {
    await this.put(email);
  };

  public readonly attest = async (attestationOptions: Awaited<ReturnType<AttestationResourceClient['get']>>) => {
    const credential = await navigator.credentials.create(attestationOptions);
    if (!(credential instanceof PublicKeyCredential))
      throw Error('Investigate further', { cause: credential });
    const {
      attestationObject,
      clientDataJSON,
    } = credential.response as AuthenticatorAttestationResponse;
    return await this.post(
      attestationOptions.credentialId,
      {
        rawId: new Uint8Array(credential.rawId),
        response: {
          attestationObject: new Uint8Array(attestationObject),
          clientDataJSON: new Uint8Array(clientDataJSON),
        },
      }
    );
  };
}